import type { ValueOf } from 'cpool-utils';

export const SpinnerSize = {
    EXTRA_LARGE: 'extra-large',
    LARGE: 'large',
    MEDIUM: 'medium',
    SMALL: 'small',
} as const;

export type SpinnerSizeType = ValueOf<typeof SpinnerSize>;
